import { isMobileOnly } from 'react-device-detect';
import { useTheme } from '@mui/material';
import { ScreenSizes } from '../../interfaces';

import { INotificationStyles } from './interfaces';

export const useStyles = ({
  color,
  hasIcon,
  colorIcon,
  background,
}: INotificationStyles) => {
  const { breakpoints } = useTheme();

  return {
    root: {
      padding: '12px 18px',
      background,
      borderRadius: '16px',
      backdropFilter: 'blur(4px)',
      border: '1px solid rgba(140, 140, 140, 0.5)',
      width: 375,
      position: 'relative',
      [breakpoints.down(ScreenSizes.Tablet)]: {
        width: '90%',
        padding: '10px 16px',
      },
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: hasIcon ? 'space-between' : 'flex-end',
      marginBottom: '10px',
    },
    closeIcon: {
      color: color,
      cursor: 'pointer',
      fontSize: isMobileOnly ? 28 : 14,
      padding: isMobileOnly ? '6px 0 6px 6px' : 0,
    },
    icon: {
      backgroundColor: colorIcon,
    },
    title: {
      fontWeight: 500,
      fontSize: 16,
      lineHeight: 1.5,
      letterSpacing: '0.1px',
      color: color,
    },
    message: {
      fontWeight: 500,
      fontSize: 14,
      lineHeight: 1.43,
      letterSpacing: '0.1px',
      color: color,
      mt: 1.5,
      [breakpoints.down(ScreenSizes.Tablet)]: {
        mt: 1,
      },
    },
    buttonsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      mt: 1.5,
      [breakpoints.down(ScreenSizes.Tablet)]: {
        mt: 1,
      },
      '> button': {
        marginLeft: '10px',
      },
    },
  };
};
